import { render, staticRenderFns } from "./IOSVersionAlertModal.vue?vue&type=template&id=6399457b"
import script from "./IOSVersionAlertModal.vue?vue&type=script&lang=ts"
export * from "./IOSVersionAlertModal.vue?vue&type=script&lang=ts"
import style0 from "./IOSVersionAlertModal.vue?vue&type=style&index=0&id=6399457b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports